module.exports = __webpack_public_path__ + "static/rencai-14623da35a68b5e8f4d35d5e8b2cf078.png";